export const getSectionNames = (sectionObj): string[] | null => {
  if (sectionObj && sectionObj.length > 0) {
    return sectionObj.map(item => item.name).join(', ')
  } else {
    return null
  }
}
